<header #header tabindex="0">
    <ng-container *atScreenResolution="'>= 600'">
        <app-upper-header></app-upper-header>
        <app-lower-header></app-lower-header>
    </ng-container>

    <ng-container *atScreenResolution="'< 600'">
        <app-mobile-header></app-mobile-header>
    </ng-container>
</header>